import { FlashCardYubikeyIcon, LaptopYubikeyIcon, MailLockIcon, ShieldYubikeyIcon } from "components/svg";

export const ADD_YOUR_YUBIKEY_ITEM = [
  { text: "Get passwordless easy: use Yubikey for log in", icon: FlashCardYubikeyIcon },
  { text: "Secure your assets against phishing with Yubikey", icon: ShieldYubikeyIcon },
  { text: "Unlock from any device, anywhere", icon: LaptopYubikeyIcon },
  { text: "Lost your Yubikey? Use email to easily return access to the account", icon: MailLockIcon },
];
